export class LinkedCustodian {
	id: string;
	issueId: string;
	name: string;
}
